<mat-form-field style="width: 100%">
    <mat-label>{{ "state" | transloco }}</mat-label>

    <mat-select [required]="required()" (valueChange)="onChangeEvent($event)" #select>
        @if (withEmptyOption()) {
            <mat-option [value]="">---</mat-option>
        }
        <mat-option value="Dormant">
            <button class="badge badge-dormant">{{ "state_inactive" | transloco }}</button>
        </mat-option>
        <mat-option value="Edit">
            <button class="badge badge-edit">{{ "state_in_progress" | transloco }}</button>
        </mat-option>
        <mat-option value="Pending">
            <button class="badge badge-pending">{{ "state_approval" | transloco }}</button>
        </mat-option>
        <mat-option value="Live">
            <button class="badge badge-live">{{ "state_active" | transloco }}</button>
        </mat-option>
    </mat-select>
</mat-form-field>
@if (required() && isEmpty) {
    <mat-error>{{ "state_nessasary" | transloco }}</mat-error>
}
